import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { BinaryDependencyConfidence } from '../../../../../../shared/binaryDependencyConfidence';
import { DependencyFilterKeys } from '../../../../../../shared/dependenciesV2';
import * as DependenciesV2Store from '../../../../../redux/dependenciesV2';
import FilterCardCheckboxes from '../../../../generic/Filter/FilterCardCheckboxes';
import useFetchDependenciesAction from '../../hooks/useFetchDependencyAction';
import type { SelectOption } from '../../../../../types';

const FILTER_LABELS: Record<BinaryDependencyConfidence, string> = {
  [BinaryDependencyConfidence.High]: 'High',
  [BinaryDependencyConfidence.Medium]: 'Medium',
  [BinaryDependencyConfidence.Low]: 'Low',
  [BinaryDependencyConfidence.Unknown]: 'Unknown',
};

const FILTER_OPTIONS: SelectOption[] = Object.entries(FILTER_LABELS).map(([value, label]) => ({
  label, value,
}));

/**
 * Dependency Confidence filter which allows the user to filter dependencies by confidence
 * (confidence is only meaningful for dependencies of binary projects)
 */
const DependencyConfidenceFilter: VoidFunctionComponent = () => {
  const filters = useSelector(DependenciesV2Store.selectors.getFilters);
  const setFilter = useFetchDependenciesAction(DependenciesV2Store.actions.setFilters);

  const selectedOptions = (filters.confidence ?? [])
    .map((option: BinaryDependencyConfidence) => (
      { label: FILTER_LABELS[option], value: option }
    ));

  const onChange = (selected: SelectOption[]) => setFilter({
    ...filters,
    [DependencyFilterKeys.Confidence]: selected.map((option) => option.value),
  });

  return (
    <FilterCardCheckboxes
      label="Dependency Confidence"
      options={FILTER_OPTIONS}
      values={selectedOptions}
      onChange={onChange}
    />
  );
};

export default DependencyConfidenceFilter;
